import ItemDetailLayout from "./selector";

export default ItemDetailLayout;
